// src/services/medicalCenterService.js
import api, { BASE_URL } from './api';


class MedicalCenterService {


    
    async getLanguages() {
      return await api.get(`${BASE_URL}/medical_centers/languages`);
    }

  // Get all programs available to attach to medical centers (admin only)
  async getAvailablePrograms() {
    return await api.get(`${BASE_URL}/programs`);
  }
  // Get all medical centers (admin only)
  async getMedicalCenters() {
    return await api.get(`${BASE_URL}/medical_centers`);
  }

  // Get single medical center
  async getMedicalCenter(medicalCenterId) {
    return await api.get(`${BASE_URL}/medical_centers/${medicalCenterId}`);
  }

  // Create new medical center (admin only)
  async createMedicalCenter(medicalCenterData) {
    return await api.post(`${BASE_URL}/medical_centers`, {
      medical_center: medicalCenterData
    });
  }

  // Update medical center (admin only)
  async updateMedicalCenter(medicalCenterId, medicalCenterData) {
    return await api.put(`${BASE_URL}/medical_centers/${medicalCenterId}`, {
      medical_center: medicalCenterData
    });
  }

  // Delete medical center (admin only)
  async deleteMedicalCenter(medicalCenterId) {
    return await api.delete(`${BASE_URL}/medical_centers/${medicalCenterId}`);
  }
}

export const medicalCenterService = new MedicalCenterService();